module.exports = __webpack_public_path__ + "static/img/menu-close.0dcf509a.svg";